const SYSTEM_GROUP_ORDER = ["public", "org", "special"];

export function getActiveCompanyId() {
    const raw = window.sessionStorage.getItem("usercompany");
    const companyId = Number(raw);
    return Number.isFinite(companyId) && companyId > 0 ? companyId : undefined;
}

export function systemUserGroupRequestParams() {
    const company = getActiveCompanyId();
    return company ? { company } : {};
}

export function normalizeSystemUserGroups(groups = []) {
    const byType = new Map();

    for (const group of groups) {
        if (!group?.group_type || byType.has(group.group_type)) {
            continue;
        }
        byType.set(group.group_type, group);
    }

    return SYSTEM_GROUP_ORDER.map((groupType) => byType.get(groupType)).filter(
        Boolean
    );
}

export function systemUserGroupSelectOptions(groups = []) {
    return normalizeSystemUserGroups(groups).map((group) => ({
        label: group.name,
        value: group.id,
        group_type: group.group_type,
    }));
}
